function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  height: "24",
  viewBox: "0 0 20 24",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.475 1.5L10.5.702l5.151 2.047L18 6.631l.545 5.362-2.259 5.085-4.729 4.871-2.118 1.129-6-5.294L.545 10.5 1.5 6l2.363-3.392z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ff4600"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.751 13.5c-.113 0-.224-.017-.332-.05a.786.786 0 01-.121-.049 1.126 1.126 0 01-.639-1.291.587.587 0 01.013-.059l.005-.015.024-.059.021-.05a1.121 1.121 0 011.289-.642c.023.004.046.01.068.016l.002.001a.507.507 0 01.068.027 1.13 1.13 0 01.696 1.289.691.691 0 01-.018.084l-.005.016a1.115 1.115 0 01-1.071.782zm-.001-3A.75.75 0 019 9.75v-3a.75.75 0 011.5 0v3a.75.75 0 01-.75.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.749 23.898c-.26 0-.517-.068-.743-.197a21.007 21.007 0 01-5.142-4.209A14.494 14.494 0 010 9.75C0 4.365 4.365 0 9.75 0s9.75 4.365 9.75 9.75a14.495 14.495 0 01-3.865 9.744 21.008 21.008 0 01-5.142 4.208 1.51 1.51 0 01-.744.196zM9.75 1.5A8.26 8.26 0 001.5 9.75c0 1.861.595 8.273 8.25 12.649C17.405 18.027 18 11.612 18 9.75A8.26 8.26 0 009.75 1.5z"
})))));